'use client';

import React from 'react';
import * as SubframeUtils from '../utils';

interface SeparatorRootProps extends React.HTMLAttributes<HTMLDivElement> {
  orientation?: 'horizontal' | 'vertical';
  className?: string;
}

const SeparatorRoot = React.forwardRef<HTMLDivElement, SeparatorRootProps>(function SeparatorRoot(
  { orientation = 'horizontal', className, ...otherProps },
  ref,
) {
  return (
    <div
      className={SubframeUtils.twClassNames('w-full pt-1 pb-2', className)}
      ref={ref}
      {...otherProps}
    >
      <div
        className={SubframeUtils.twClassNames(
          'bg-neutral-200',
          orientation === 'horizontal' ? 'h-px w-full' : 'h-full w-px',
        )}
      />
    </div>
  );
});

export const Separator = SeparatorRoot;
